import { connect } from "react-redux";
import { useState } from "react";
import { Modal, Row, Col, Button, Form } from "react-bootstrap";
import { post_archivo } from "../../services/documentos";

function SubirArchivo({ contrato, show, close, onUploadSuccess }) {
  const [file, setFile] = useState(false);
  const [descrip, setDescrip] = useState("");

  const cerrar = () => {
    close(false);
  };

  const subirArchivo = async () => {
    const params = {
      descrip,
      polissa_id: contrato.id,
      sector_type: contrato.sector_type,
    };
    try {
      await post_archivo(file, params);
      cerrar();
      if (onUploadSuccess) {
        onUploadSuccess();
      }
    } catch (error) { }
  };

  return (
    <Modal
      show={show}
      size="md"
      backdrop="static"
      centered
      contentClassName="border-0 rounded-4 shadow-lg"
    >
      <Modal.Header className="bg-white border-bottom-0" closeButton onHide={cerrar}>
        <div className="d-flex flex-column">
          <Modal.Title className="fw-bold text-primary">Cargar Archivo</Modal.Title>
          <span className="text-muted small">Contrato Nº {contrato?.name || ''}</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold small text-muted text-uppercase">Tipo de archivo</Form.Label>
            <Form.Select
              className="form-control rounded-3 border-light shadow-sm bg-light"
              value={descrip}
              onChange={e => setDescrip(e.target.value)}
            >
              <option value="">Seleccionar tipo</option>
              <option value="cif_nif">CIF/NIF</option>
              <option value="boletin">Boletin</option>
              <option value="lectura">Lectura</option>
              <option value="mod_pot">Modificacion de potencia</option>
              <option value="_def">Baja definitiva</option>
              <option value="sepa">SEPA</option>
              <option value="reclamacion">Reclamacion</option>
              <option value="OTROS">Otros</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="fw-bold small text-muted text-uppercase">Documento</Form.Label>
            <Form.Control
              type="file"
              className="rounded-3 border-light shadow-sm bg-light"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0">
        <Button
          variant="outline-secondary"
          className="rounded-pill px-4 fw-bold"
          onClick={cerrar}
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          disabled={!descrip || !file}
          className="rounded-pill px-4 fw-bold shadow-sm"
          onClick={() => subirArchivo()}
        >
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default connect()(SubirArchivo);
